export const getters = {
    getLancamentoCaixa : state => state.lancamentoCaixa,
    getLancamentosCaixa : state => state.lancamentosCaixa,
    getModalCadastroLancamentoCaixa : state => state.modalCadastroLancamentoCaixa,
    getModalExcluirLancamentoCaixa : state => state.modalExcluirLancamentoCaixa,
    getModalListarLancamentoCaixa : state => state.modalListarLancamentoCaixa,
    getLancamentoCaixaTipos : state => state.lacamentoCaixaTipos,
    getModalRelatorioFechamentoCaixa: state => state.modalRelatorioFechamentoCaixa,
    getFormaPagamentoSelecionadaLancamentoCaixa: state => state.formaPagamentoSelecionadaLancamentoCaixa
}

export default {}

